import {
    THANA_LIST_PARTNER_SUCCESS,
    THANA_LIST_PARTNER_FAILED,
    RESET_THANA_LIST_PARTNER,
    LOADING_THANA_LIST_PARTNER,
    NETWORK_ERROR_THANA_LIST_PARTNER
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_THANA_LIST_PARTNER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case THANA_LIST_PARTNER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case THANA_LIST_PARTNER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_THANA_LIST_PARTNER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_THANA_LIST_PARTNER:
            return (state = initialState);
        default:
            return state;
    }
};
